import { combineReducers } from "redux";

import submission from './GenericFormServices/SubmissionReducer';
import loadDraft from './GenericFormServices/LoadDraftReducer';
import saveDraft from './GenericFormServices/SaveDraftReducer';
import hasDraftsIndividual from './GenericFormServices/HasDraftsIndividualReducer';
import hasDraftsOrganisation from './GenericFormServices/HasDraftsOrganisationReducer';
import deleteDraft from './GenericFormServices/DeleteDraftReducer';

import getMtoCertificate from './GenericFormServices/GetMtoCertificateDetailsReducer';
import verifyUserRole from './IndustryAssist/VerifyUserRoleReducer';
import verificationViewData from './DigitalLicenceServiceReducer/VerificationViewDataReducer';
import esbReferenceData from './MplFormServices/GetEsbReferenceDataReducer';
import studentVerification from './MplFormServices/StudentVerificationReducer';
import certificateList from './CertificateManagement/GetCertificateListReducer';
import validateHmac from './GenericFormServices/ValidateHmacReducer';
import getAdditionalPaymentSubmissions from './RequestPayment/GetAdditionalPaymentSubmissionsReducer';
import selectedPaymentSubmission from './RequestPayment/GetSinglePaymentSubmissionReducer';
import additionalPaymentSubmission from './RequestPayment/AdditionalPaymentSubmissionReducer';
import cancellationSubmissionDetails from './CancellationReason/GetSubmissionDetailsFromSubmissionId';
import requestCloseSubmission from './CancellationReason/RequestCloseSubmissionCrmAction';

export default combineReducers({
    submission,
    loadDraft,
    saveDraft,
    deleteDraft,
    hasDraftsIndividual,
    hasDraftsOrganisation,
    getMtoCertificate,
    verifyUserRole,
    verificationViewData,
    esbReferenceData,
    studentVerification,
    certificateList,
    validateHmac,
    getAdditionalPaymentSubmissions,
    selectedPaymentSubmission,
    additionalPaymentSubmission,
    cancellationSubmissionDetails,
    requestCloseSubmission
});